import { Link } from "react-router-dom";

const quickLinks = [
  { label: "首页", path: "/" },
  { label: "新闻资讯", path: "/news" },
  { label: "剧情介绍", path: "/plot" },
  { label: "演员阵容", path: "/cast" },
  { label: "影视推荐", path: "/recommend" },
  { label: "关于我们", path: "/about" },
  { label: "联系我们", path: "/contact" },
];

const socials = [
  { icon: "ri-weibo-fill", label: "微博" },
  { icon: "ri-wechat-fill", label: "微信" },
  { icon: "ri-youtube-fill", label: "视频频道" },
  { icon: "ri-instagram-fill", label: "图片分享" },
];

export default function Footer() {
  return (
    <footer className="bg-primary-50">
      <div className="mx-auto max-w-[1200px] px-4 py-12 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <div className="mb-3 flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-leaf-line w-5 h-5 flex items-center justify-center text-lg text-background-50"></i>
              </span>
              <span className="font-heading text-base font-bold text-foreground-950">
                蜜桃成熟时3D
              </span>
            </div>
            <p className="text-sm leading-relaxed text-foreground-600">
              专注呈现「蜜桃成熟时3D」的最新电影资讯、剧情解读与演员资料，为影迷提供一处可以慢慢阅读的影视资讯空间。
            </p>
          </div>

          <div>
            <h4 className="mb-4 font-heading text-sm font-bold text-foreground-950">快速导航</h4>
            <ul className="grid grid-cols-2 gap-x-4 gap-y-2 text-sm text-foreground-600">
              {quickLinks.map((item) => (
                <li key={item.path}>
                  <Link to={item.path} className="transition-colors hover:text-primary-700">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="mb-4 font-heading text-sm font-bold text-foreground-950">内容分类</h4>
            <ul className="space-y-2 text-sm text-foreground-600">
              <li><Link to="/news" className="transition-colors hover:text-primary-700">影片动态与影展资讯</Link></li>
              <li><Link to="/plot" className="transition-colors hover:text-primary-700">剧情章节与故事线索</Link></li>
              <li><Link to="/cast" className="transition-colors hover:text-primary-700">演员阵容与角色资料</Link></li>
              <li><Link to="/recommend" className="transition-colors hover:text-primary-700">同类风格影视推荐</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="mb-4 font-heading text-sm font-bold text-foreground-950">联系我们</h4>
            <ul className="space-y-3 text-sm text-foreground-600">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line mt-0.5 w-4 h-4 flex items-center justify-center text-primary-600"></i>
                <span>contact@peach3d-movie.com</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-phone-line mt-0.5 w-4 h-4 flex items-center justify-center text-primary-600"></i>
                <span>400-620-2026（工作日 9:00-18:00）</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line mt-0.5 w-4 h-4 flex items-center justify-center text-primary-600"></i>
                <span>蜜桃海岸小镇 · 影视文化园区 B 座</span>
              </li>
            </ul>
            <div className="mt-4 flex flex-wrap gap-2">
              {socials.map((s) => (
                <span
                  key={s.label}
                  title={s.label}
                  className="flex h-9 w-9 items-center justify-center rounded-md bg-background-50 text-foreground-600 transition-colors hover:bg-accent-500 hover:text-background-50"
                >
                  <i className={`${s.icon} text-lg`}></i>
                </span>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-primary-100 pt-6 text-xs text-foreground-500 sm:flex-row">
          <p>© {new Date().getFullYear()} 蜜桃成熟时3D · 影视资讯门户. 本网站内容为虚构演示样例，仅供学习与展示。</p>
          <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1">
            <Link to="/about" className="transition-colors hover:text-primary-700">关于我们</Link>
            <Link to="/contact" className="transition-colors hover:text-primary-700">联系我们</Link>
            <span>图片均为演示素材</span>
          </div>
        </div>
      </div>
    </footer>
  );
}